module.exports = elementChinaAreaData;